import classNames from 'clsx';
import React from 'react';

import styles from './Header.scss';

export enum Variant {
  Dark = 'dark',
  Light = 'light'
}

export interface Props {
  className?: string;
  variant?: Variant;
}

const Header: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  variant = Variant.Light
}) => (
  <header
    className={classNames(styles.header, className, {
      [styles.dark]: variant === 'dark'
    })}
  >
    {children}
  </header>
);

export default Header;
